<template>
    <div class="mt-lg-3 mt-1 pt-3 pb-0 px-3">
        <b-card class="vld-parent card-material" header="Profile" header-border-variant="light">
            <h5 slot="header" class="mb-0" style="border-bottom: none !important;">Profile</h5>

            <strong>General</strong>
            <hr>

            <b-row class="pb-3">
                <b-col cols="6" sm="2">
                    <label>My Email</label>
                </b-col>

                <b-col sm="4">
                    <label> {{userEmail}} </label>
                </b-col>
            </b-row>

            <update-password></update-password>

            <notifications></notifications>

            <div v-if="showingBottomNav">
                <strong>Other</strong>
                <hr>
                <b-btn class="mt-1" variant="primary" @click="logout">
                    Logout
                </b-btn>
            </div>
        </b-card>

        <InfoModal></InfoModal>

        <ErrorModal></ErrorModal>
    </div>
</template>

<script>
    import store from '@/store';
    import {mapGetters, mapActions} from 'vuex';
    import UpdatePassword from "@/components/settings/UpdatePassword";
    import Notifications from "@/components/settings/Notifications";
    import InfoModal from "@/components/general-purpose-modals/InfoModal";
    import ErrorModal from "@/components/general-purpose-modals/ErrorModal";
    import {isMobileNavigationMode} from "@/utilities/mobile.navigation.utility";

    export default {
        name: "Settings",

        components: {
            UpdatePassword,
            Notifications,
            InfoModal,
            ErrorModal
        },

        computed: {
            ...mapGetters({
                userEmail: 'user/email'
            }),

            showingBottomNav: function () {
                return isMobileNavigationMode(this.$platform);
            }
        },

        async beforeRouteEnter(to, from, next) {
            await store.dispatch('user/fetchUserSettings');
            next();
        },

        methods: {
            ...mapActions('auth', [
                'logout'
            ])
        }
    }
</script>

<style scoped>

</style>


































